import css from 'styled-jsx/css';

export default css`
  .main-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 4%;
    flex-direction: row;
  }
  .card-container {
    display: flex;
    justify-content: start;
    align-items: center;
    flex-direction: column;
    width: 257px;
    background-color: #131313;
    padding: 20px;
    border-radius: 3px;
    margin-left: 3%;
    height: 510px;
    position: relative;
  }
  .icon {
    margin-top: 5%:
  }
  .title {
    font-family: 'Eurostile-Bold';
    font-size: 26px;
    margin-top: 5%;
    margin-bottom: 0;
    text-align: center;
    text-transform: uppercase;
  }
  .description {
    font-size: 14px;
    text-align: center;
    height: 145px;
  }
  .email-us {
    margin-top: 5%;
    font-size: 14px;
  }
  .email {
    font-size: 13px;
    color: #4992FF;
    cursor: pointer;
  }
  .btn {
    background-color: #950810;
    font-size: 13px;
    color: white;
    width: 137px;
    height: 32px;
    border-radius: 3px;
    border: none;
    margin-top: 10%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
  }
  @media (max-width: 600px) {
    .main-container {
      -webkit-justify-content: initial;
      overflow: auto;
      margin-top: 10%;
      margin-left: 6%;
    }
    .description-container {
      width: 225px;
    }
    .card-container {
      height: 440px;
      margin-right: 5%;
    }
    .title {
      font-size: 20px;
    }
    .description {
      font-size: 12px;
      line-height: 20px;
    }
    .email-us {
      font-size: 13px;
    }
    ::-webkit-scrollbar {
      display: none;
    }
  }
  .email-btn-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: absolute;
    bottom: 5%;
  }
`;